import * as React from 'react';
import SurveyLayout from '../../Layout/SurveyLayout';
import SurveyForm from '../../SurveyForm';

const Initial = () => {
  return (
    <SurveyLayout>
      <SurveyForm />
    </SurveyLayout>
  );  
};
export default Initial;